var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAvatarPlaceholder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 48 48",
    preserveAspectRatio: "xMidYMid slice",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#512936",
    d: "M0 0h48v48H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.488 26.747a6.606 6.606 0 11-3.42 12.762 6.606 6.606 0 013.42-12.762zM31.599 22.13a2.785 2.785 0 01-3.798-1.04l-3.235-5.678a2.784 2.784 0 011.04-3.798l5.678-3.235a2.784 2.784 0 013.798 1.04l3.235 5.678a2.784 2.784 0 01-1.04 3.798l-5.678 3.235z",
    fill: "#B08A8E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.157 28.775a2.529 2.529 0 00.926-3.454l-1.265-2.19 2.19-1.265a2.529 2.529 0 00-2.529-4.38l-2.19 1.264-1.264-2.19a2.529 2.529 0 00-4.38 2.53l1.264 2.19-2.19 1.264a2.529 2.529 0 002.529 4.38l2.19-1.264 1.264 2.19a2.529 2.529 0 003.455.925z",
    fill: "#B08A8E"
  })));
}

export default SvgAvatarPlaceholder;